/* eslint-disable import-x/no-default-export */
import Chance from 'chance';

const chance = new Chance();
const firstName = chance.first().toLowerCase().replace(/\s+/g, '');
const lastName = chance.last().toLowerCase().split(' ')[0];
const hash = chance.string({ length: 6, alpha: true, numeric: true });
const slug = `${firstName}-${lastName}-${hash}`;

export default () => ({
  url: () => `https://www.seek.com.au/profiles/${slug}`,
  displayUrl: () => `www.seek.com.au/profiles/${slug}`,
});
